import { render } from "./ChangeTypeField.vue?vue&type=template&id=70809211"
import script from "./ChangeTypeField.vue?vue&type=script&lang=js"
export * from "./ChangeTypeField.vue?vue&type=script&lang=js"

import "./ChangeTypeField.vue?vue&type=style&index=0&id=70809211&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__